var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.3374 9.93841C1.3374 8.71422 1.89798 7.55744 2.85883 6.79888L8.35883 2.45677C9.81206 1.30948 11.8627 1.30948 13.316 2.45677L18.816 6.79888C19.7768 7.55744 20.3374 8.71422 20.3374 9.93841V16.5C20.3374 18.7091 18.5465 20.5 16.3374 20.5H14.8374C14.2851 20.5 13.8374 20.0523 13.8374 19.5V16.5C13.8374 15.3954 12.942 14.5 11.8374 14.5H9.8374C8.73283 14.5 7.8374 15.3954 7.8374 16.5V19.5C7.8374 20.0523 7.38969 20.5 6.8374 20.5H5.3374C3.12826 20.5 1.3374 18.7091 1.3374 16.5L1.3374 9.93841Z",
    fill: "#EDA30E",
    stroke: "#EDA30E",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledHome);
export default __webpack_public_path__ + "static/media/filled-home.2a71f36462bfb86c6f78047a2561a7a4.svg";
export { ForwardRef as ReactComponent };